import {
    AutoplayOptions,
    PartialAutoplayOptions
} from '@gongxigames/framework/slot/types';
import {ReasonID} from '@gongxigames/framework/core';
import {AutoplayShowOptionsPopupProperties} from '@gongxigames/framework/slot/modules/autoplayOptions/AutoplayOptionsPopup';

export type StrictAutoplayEvents = {
    'Autoplay.SHOW_OPTIONS_POPUP': AutoplayShowOptionsPopupProperties;
    'Autoplay.HIDE_OPTIONS_POPUP': void;
    'Autoplay.START': AutoplayOptions;
    'Autoplay.START_SPIN': void;
    'Autoplay.STARTED': void;
    'Autoplay.FORCE_STOP': void;
    'Autoplay.STOPPED': void;
    'Autoplay.CHANGED_OPTION': PartialAutoplayOptions;
    'Autoplay.StopButton.ENABLE': ReasonID;
    'Autoplay.StopButton.DISABLE': ReasonID;
};
